import React, { useRef, useState } from 'react';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import ColorConstants from 'constants/ColorConstants';

// White card tooltip with an arrow — matches the prototype's tooltips (and the
// dashboard's column-header tooltip).
export const WHITE_TOOLTIP_PROPS = {
  arrow: true,
  slotProps: {
    tooltip: {
      sx: {
        backgroundColor: ColorConstants.WHITE,
        color: ColorConstants.GRAY_900,
        border: `1px solid ${ColorConstants.GRAY_200}`,
        borderRadius: '8px',
        boxShadow: '0 6px 20px rgba(0,0,0,0.12)',
        maxWidth: 320,
        p: 1.5,
        fontSize: 13,
      },
    },
    arrow: { sx: { color: ColorConstants.WHITE, '&::before': { border: `1px solid ${ColorConstants.GRAY_200}` } } },
  },
};

// Single-line ellipsized text that reveals the full value in a white-card
// tooltip only when it's actually truncated (too long for its column).
// Truncation is measured on hover — when layout is settled — and the tooltip is
// controlled, so it works on the first hover and never fires for text that
// fits. Pass the text as children; styling overrides go through sx.
function OverflowTooltip({ children, sx, ...props }) {
  const ref = useRef(null);
  const [open, setOpen] = useState(false);

  const handleMouseOver = () => {
    const el = ref.current;
    if (el && el.scrollWidth > el.clientWidth) setOpen(true);
  };

  return (
    <Tooltip
      title={children}
      open={open}
      onClose={() => setOpen(false)}
      placement="top-start"
      disableHoverListener
      disableFocusListener
      disableTouchListener
      {...WHITE_TOOLTIP_PROPS}
    >
      <Typography
        ref={ref}
        onMouseOver={handleMouseOver}
        onMouseOut={() => setOpen(false)}
        sx={{ flex: 1, minWidth: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', ...sx }}
        {...props}
      >
        {children}
      </Typography>
    </Tooltip>
  );
}

export default OverflowTooltip;
